import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import TelegramPairSelector, { togglePair } from "./TelegramPairSelector";
import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialDialog from "../../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../styles/styledDialog";

const TelegramEditConnectionDialog = ({ open, onClose, conn, setNotification, onSaved, t }) => {
  const [pairs, setPairs]               = useState([]);
  const [availablePairs, setAvailablePairs] = useState([]);
  const [loadingPairs, setLoadingPairs] = useState(false);

  useEffect(() => {
    if (!conn) return;
    setPairs(conn.pairs || []);
    setAvailablePairs([]);
    if (!conn.connectionId) return;
    setLoadingPairs(true);
    axios.get(`/api/connections/${conn.connectionId}`, userAuthenticationConfig())
      .then(r => {
        const serviceId = r.data?.service?.id;
        if (!serviceId) return null;
        return axios.get(`/api/service-relationships?service.id=${serviceId}`, userAuthenticationConfig());
      })
      .then(r => r && setAvailablePairs(r.data["hydra:member"] || []))
      .catch(() => setAvailablePairs([]))
      .finally(() => setLoadingPairs(false));
  }, [conn]);

  const handleEdit = () => {
    axios.put(`/api/telegram/project-connections/${conn.id}`, { pairs }, userAuthenticationConfig())
      .then(() => {
        onClose();
        setNotification({ visible: true, type: "success", message: t("connections.success.updated") });
        onSaved();
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("connections.errors.update") });
      });
  };

  return (
    <MaterialDialog open={open}>
      <StyledDialogWrapper>
        <StyledDialogHead>
          {t("connections.dialog.editTitle")}
        </StyledDialogHead>
        <StyledDialogContent>
          {conn ? (
            <Alert severity="info">
              <p><strong>{conn.connectionName}</strong> — {conn.serviceName}</p>
              <p>{conn.type}</p>
            </Alert>
          ) : <></>}
          <Box mt={1}>
            <Typography variant="caption" color="textSecondary">{t("connections.dialog.pairsLabel")}</Typography>
            <TelegramPairSelector
              available={availablePairs}
              selected={pairs}
              onToggle={(cId, psId) => setPairs(prev => togglePair(prev, cId, psId))}
              loading={loadingPairs}
              t={t}
            />
          </Box>
        </StyledDialogContent>
        <StyledDialogAction col="2">
          <DefaultButton onClick={onClose} color="danger">
            {t("connections.dialog.cancel")}
          </DefaultButton>
          <DefaultButton onClick={handleEdit} color="success">
            {t("connections.dialog.save")}
          </DefaultButton>
        </StyledDialogAction>
      </StyledDialogWrapper>
    </MaterialDialog>
  );
};

export default TelegramEditConnectionDialog;